import httpClient from '@/utilities/service/httpClient'
import AbstractApi from '@/api/abstracts/AbstractApi'
// eslint-disable-next-line prettier/prettier
import type { PermissionsType, PermissionSavedType } from '@/api/types/response/PermissionsType'
import type { PermissionPayloadType } from '@/api/types/request/PermissionPayloadType'

/**
 * @property string apiEnd /api/adjustment/permission
 */
export default class PermissionApi extends AbstractApi {
  all(): Promise<PermissionsType> {
    return httpClient.get(this.apiEnd)
  }

  save(payload: PermissionPayloadType[]): Promise<PermissionSavedType> {
    return httpClient.put(this.apiEnd, { permissions: payload })
  }
}
